module.exports = __webpack_public_path__ + "img/redux.34c54253.png";